import styled from '@emotion/styled';
import { breakpoints } from '~/theme';

export const Container = styled.div(({ theme }) => ({
    [breakpoints.sm]: {
        marginTop: theme.space[5],
    },
}));
